<template>
  <div
    class="header-mega-menu-module"
    :class="[{ show: subActive }, { 'image-style': isImageStyle }]"
    @mouseleave="onMouseLeave()"
  >
    <div class="image-grid" v-if="isImageStyle">
      <h3 class="title">
        {{ links.menu_title }}
        <small>{{ links.subtitle }}</small>
      </h3>

      <div class="links flex">
        <a
          class="item"
          v-for="link of links.children"
          :key="link.id"
          :href="link.url"
        >
          <div class="image">
            <img :src="link.image" :alt="link.title" />
          </div>
          <h4>
            {{ link.title }}
            <small>{{ link.subtitle }}</small>
          </h4>
        </a>
      </div>
    </div>

    <div class="tile-grid flex" v-else>
      <div class="left">
        <h3 class="title">
          {{ links.menu_title }}
          <center><i><small>{{ links.subtitle }}</small></i></center>
        </h3>

        <div class="links flex flex-between">
          <a
            class="link-large-gray"
            v-for="link of links.children"
            :key="link.id"
            :href="link.url"
          >
            {{ link.title }}
            <br/>
            <i><small>{{ link.subtitle }}</small></i>
          </a>
        </div>
      </div>
      <div class="grid-sidebar">
        <h4>{{ links.menu_description }}</h4>

        <a
          v-if="links.menu_button_link !== ''"
          :href="links.menu_button_link"
          class="button large white-border"
          >{{ links.menu_button_text }}</a
        >
      </div>
    </div>
  </div>
</template>

  <script>
  export default {
    props: {
      links: Object,
      subActive: Boolean,
      isImageStyle: Boolean,

    },
    data () {
      return {
        addOpacity: false,

      };
    },
    watch: {
      'links' () {
        this.isThisAnImageStyle()
      }
    },
    mounted () {
      this.isThisAnImageStyle()
    },
    methods: {
      onMouseLeave() {
          console.log(this.links.template)
          if (this.links.template === "Thumbnails") {
              this.isImageStyle = true;
          }
        //this.$emit("onMouseLeave");
      },
    },
    mounted() {
      if (this.links.template === "Thumbnails") {
        this.isImageStyle = true;
      }
      else {
          this.isImageStyle = false;
      }

    },
  };
  </script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HeaderMegaMenu.vue